import React from 'react';
import styles from './icons.module.css';

interface IPlusIconProps {
    color?: string;
}

export function PlusLoopIcon({ color = '#333' }: IPlusIconProps) {
    return (
        <svg width="20" height="20" x="0px" y="0px" viewBox="0 0 97.5 97.5">
            <g>
                <path d="M56.8,0.4c-22.2,0-40.3,18.1-40.3,40.3c0,9.5,3.3,18.2,8.8,25.1L1.7,89.5c-1.8,1.8-1.8,4.6,0,6.4c0.9,0.9,2,1.3,3.2,1.3
                    s2.3-0.4,3.2-1.3l23.6-23.6c6.9,5.5,15.6,8.8,25.1,8.8c22.2,0,40.3-18.1,40.3-40.3S79.1,0.4,56.8,0.4z M56.8,72
                    C39.5,72,25.5,58,25.5,40.7S39.5,9.4,56.8,9.4s31.3,14.1,31.3,31.3S74.1,72,56.8,72z"></path>
                <path d="M72.4,36.2h-11v-11c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5v11h-11c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h11v11
                    c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5v-11h11c2.5,0,4.5-2,4.5-4.5S74.9,36.2,72.4,36.2z"></path>
            </g>
        </svg>
    );
}
